export const ADSLINK_CREATE_ACTIONS = {
    ADSLINK_CREATE_REQUEST: "ADSLINK_CREATE_REQUEST",
    ADSLINK_CREATE_RESPONSE: "ADSLINK_CREATE_RESPONSE",
    ADSLINK_CREATE_ERROR: "ADSLINK_CREATE_ERROR",
  };
  
  
  export const ADSLINK_LIST_ACTIONS = {
    ADSLINK_LIST_REQUEST: "ADSLINK_LIST_REQUEST",
    ADSLINK_LIST_RESPONSE: "ADSLINK_LIST_RESPONSE",
    ADSLINK_LIST_ERROR: "ADSLINK_LIST_ERROR",
  };
  
  export const ADMINPOSTBYID_LIST_ACTIONS = {
    ADMINPOSTBYID_LIST_REQUEST: "ADMINPOSTBYID_LIST_REQUEST",
    ADMINPOSTBYID_LIST_RESPONSE: "ADMINPOSTBYID_LIST_RESPONSE",
    ADMINPOSTBYID_LIST_ERROR: "ADMINPOSTBYID_LIST_ERROR",
  };
  
  
  export const ADSLINK_UPDATE_ACTIONS = {
    ADSLINK_UPDATE_REQUEST: "ADSLINK_UPDATE_REQUEST",
    ADSLINK_UPDATE_RESPONSE: "ADSLINK_UPDATE_RESPONSE",
    ADSLINK_UPDATE_ERROR: "ADSLINK_UPDATE_ERROR",
  };
  
  
  export const ADSLINK_DELETE_ACTIONS = {
    ADSLINK_DELETE_REQUEST: "ADSLINK_DELETE_REQUEST",
    ADSLINK_DELETE_RESPONSE: "ADSLINK_DELETE_RESPONSE",
    ADSLINK_DELETE_ERROR: "ADSLINK_DELETE_ERROR",
  };
  export const ADSLINK_INACTIVE_ACTIONS = {
    ADSLINK_INACTIVE_REQUEST: "ADSLINK_INACTIVE_REQUEST",
    ADSLINK_INACTIVE_RESPONSE: "ADSLINK_INACTIVE_RESPONSE",
    ADSLINK_INACTIVE_ERROR: "ADSLINK_INACTIVE_ERROR",
  };
  
  